import React, { useState, useEffect } from "react";
import {getUserProducts, getLakayUser } from "../auth/apiProduct";
import Slider from '../slider/swiperProduct'
import { isAuthenticated} from "../auth";

// "Lakay <shop>" carousel of Product Preview (original design). userID = the
// owner, shopId = the EXACT shop of the preview context: its name, its
// products and its link -- never another shop of the same owner.
const NewProduct = ({
    laguangeElakay,
    infoSource,
    addressShop,
    userID,
    shopId = null,
    readUser,
    showB,
    edit = false
}) => {
      const { token } = isAuthenticated() || {};
    const [productsByArrival, setProductsByArrival] = useState([]);
    const [ShopName, setShopName] = useState('seller');

    useEffect(() => {
        let canceled = false
        if(edit){
            loadProductsByArrivalUser(token, () => canceled)
        }else{
        loadProductsByArrival(userID, 0, 24, () => canceled)
        }
        return () => { canceled = true }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userID, shopId])

    let myStyles = {
        width: "100%",
        backgroundColor: '#f0f0f0'
    }

    const loadProductsByArrival = (userID, skip, limit, isCanceled) => {
        setProductsByArrival([])
        setShopName('seller')
        userID && getLakayUser(userID, skip, limit, "createdAt", null, undefined, {filters : {}, facet:["shopLakayUser"]}, undefined, shopId).then(data => {
            if (isCanceled()) return
            if(!data || data.error || data.products && data.products?.length === 0 ){
            }else{
            setProductsByArrival(data.products);
            const ownerName = data.owner && data.owner.shopName && Array.isArray(data.owner.shopName) ? data.owner.shopName[0] : data.owner && data.owner.shopName
            setShopName(data.shop?.name || ownerName || "Lakay");
            }
        })
    };

const loadProductsByArrivalUser = (token, isCanceled) => {
     const filterUrl =  { search: '' || undefined, category: 'null' }
        getUserProducts(token, 0, 50, {sortBy:'createdAt', asc: 'asc'}, 3,  filterUrl, {"categoriesID.gategoriesLink": [] }).then(data => {
            if (!data || isCanceled()) {
            } else {
                setProductsByArrival(data.products);
            }
        });
    }

    return (
<>
        <Slider
            laguangeElakay={laguangeElakay}
            infoSource ={infoSource}
            ProductSwiper={productsByArrival}
            currentShopId={shopId}
            // User={readUser}
            nameSlider={edit ? infoSource.laguangeElakay('headNenu', infoSource.languageAPI).myShop : `Lakay ${ShopName}`}
            linkSlider={edit ? `/myshop`:`/lakay-ShopSeller/${userID}${shopId ? `?shop=${encodeURIComponent(shopId)}` : ''}`}
            myStyles={myStyles}
            showB={showB}
            showShopV={false}
            edit ={edit}
        />
</>
    )

};

export default NewProduct;
